import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { clientConfigFn } from "clientConfig";
export const MoneyFormatted = (props) => {
    const classes = classNames(props.className, "money");
    return (_jsx("span", { className: classes, children: (props.amount ?? 0).toLocaleString(clientConfigFn().currencyLocale, {
            style: "currency",
            currency: clientConfigFn().currencyFormat,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }) }));
};
